import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from 'query';
import { deleteComment } from '../../services';
import type { CommentBookmarkDeleteAction } from '../../types';
import { patchContentObjectCommentsCount } from '../../utils';
import { useDeleteComment } from '../hooks';

export const useDeleteCommentMutation = () => {
  const deleteCommentFromQueryCache = useDeleteComment();
  const queryClient = useQueryClient();

  return useMutation<unknown, CommentBookmarkDeleteAction>({
    mutationFn: async ({ id }) => deleteComment(id),
    onSuccess(_, params) {
      const numberOfDeletedReplies = deleteCommentFromQueryCache(params);
      patchContentObjectCommentsCount({
        delta: -(1 + numberOfDeletedReplies),
        id: params.contentObjectId,
        queryClient,
      });
    },
  });
};
